export default {"src":"/_next/static/media/gift.a3ccba89.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};